import {
  getPluginsStatus,
  useGetPluginsStatus,
  getGetPluginsStatusQueryKey
} from '@cdf/api-client-react';
import type { PluginsStatus } from '@cdf/api-client-react';

export interface UsePluginStatusResult {
  plugins: PluginsStatus | undefined;
  isLoading: boolean;
  isError: boolean;
}

/**
 * Plugin registry status from the API. Cached aggressively — plugin
 * availability only changes when the server environment changes.
 *
 * Uses a non-abortable queryFn so React Strict Mode / observer churn does
 * not surface AbortError on /api/plugins/status in the network log.
 */
export function usePluginStatus(): UsePluginStatusResult {
  const query = useGetPluginsStatus({
    query: {
      queryKey: getGetPluginsStatusQueryKey(),
      queryFn: () => getPluginsStatus(),
      staleTime: 5 * 60_000,
      gcTime: 30 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: 2
    }
  });
  return {
    plugins: query.data,
    isLoading: query.isLoading,
    isError: query.isError
  };
}
